export function getRole(resource_type) {
  if (resource_type.is_assistant) return 'Assistant'
  else if (resource_type.is_provider) return 'Provider'
  else return ''
}
